import React, { useState } from 'react';
import { gql } from '@apollo/client';
import { ControlLink, Breakpoint, SlidingPane } from '@moda/om';
import { SizeGuideFragment } from '../../generated/types';
import { SizeGuideModal } from './SizeGuideModal';
import { SizeGuide } from './SizeGuide';
import { hasSizeEquivalents } from './groupSizesByRegion';
import './SizeGuideLink.scss';

export const SIZE_GUIDE_FRAGMENT = gql`
  fragment SizeGuideFragment on Inventory {
    sku
    size
  }
`;

type Props = {
  className?: string;
  sizes: SizeGuideFragment[];
  sizeEquivalents: string[][];
  fitRecommendation?: string | null;
};

export const SizeGuideLink: React.FC<Props> = ({
  className,
  sizes,
  sizeEquivalents,
  fitRecommendation
}) => {
  const [showGuide, setShowGuide] = useState(false);

  if (!hasSizeEquivalents(sizeEquivalents)) return null;

  return (
    <>
      <ControlLink
        className={className}
        data-test-id="size-guide-control-link"
        onClick={() => setShowGuide(true)}
      >
        Size Guide
      </ControlLink>

      <Breakpoint className="SizeGuideLink__breakpoint" gt="md">
        <SizeGuideModal
          show={showGuide}
          sizes={sizes}
          sizeEquivalents={sizeEquivalents}
          fitRecommendation={fitRecommendation}
          onClose={() => setShowGuide(false)}
        />
      </Breakpoint>

      <Breakpoint className="SizeGuideLink__breakpoint" lt="md">
        <SlidingPane title="Size Guide" visible={showGuide} onClose={() => setShowGuide(false)}>
          <SizeGuide
            sizes={sizes}
            sizeEquivalents={sizeEquivalents}
            fitRecommendation={fitRecommendation}
          />
        </SlidingPane>
      </Breakpoint>
    </>
  );
};
